import gql from 'graphql-tag';
import {useQuery} from 'react-apollo';

import * as Generated from '../../generated/graphql';
import {fragments, ViewMetadata} from '../../graphql/views';
import {Graph} from '../../types/graphql';
import {AccessOptions} from '../../util/permissions';

///// Query definition

export const REPORT_TABLE_QUERY = gql`
  query ReportTable(
    $projectName: String!
    $entityName: String
    $draftsOffset: Int = 0
    $draftsPageSize: Int = 100
    $publishedOffset: Int = 0
    $publishedPageSize: Int = 100
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      access
      readOnly
      reportDrafts: allViews(
        viewType: "runs/draft"
        first: $draftsPageSize
        offset: $draftsOffset
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          node {
            id
            ...ViewFragmentMetadata
          }
        }
      }
      reports: allViews(
        viewType: "runs"
        first: $publishedPageSize
        offset: $publishedOffset
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          node {
            id
            ...ViewFragmentMetadata
          }
        }
      }
    }
  }
  ${fragments.viewMetadata}
`;

export interface ProjectData {
  id: string;
  access: AccessOptions;
  readOnly: boolean;
  reportDrafts: Graph<ViewMetadata>;
  reports: Graph<ViewMetadata> & {
    pageInfo: {hasNextPage: boolean; hasPreviousPage: boolean};
    totalCount: number;
  };
}

export interface ReportTableQueryData {
  project: ProjectData;
}

export function useReportTableQuery(
  variables: Generated.ReportTableQueryVariables
) {
  return useQuery<ReportTableQueryData, typeof variables>(REPORT_TABLE_QUERY, {
    fetchPolicy: 'network-only',
    variables,
  });
}
